import { languageTag, LANGUAGE } from '../i18n';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageSeo, pageSchema, SITE_ORIGIN, languageAlternates } from '../content/seo';

export default function PageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = pageSeo(pathname);
    document.title = page.title;
    document.documentElement.lang = languageTag;
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());
    for (const alternate of languageAlternates(page)) {
      const el = document.createElement("link"); el.rel = "alternate"; el.hreflang = alternate.lang; el.href = alternate.href; document.head.appendChild(el);
    }
    const fields = [
      ['name', 'description', page.description],
      ['name', 'robots', page.noindex ? 'noindex,follow' : 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1'],
      ['property', 'og:locale', LANGUAGE + '_CH'], ['property', 'og:title', page.title], ['property', 'og:description', page.description],
      ['property', 'og:url', SITE_ORIGIN + page.path],
      ['name', 'twitter:title', page.title], ['name', 'twitter:description', page.description],
    ];
    for (const [attribute, key, content] of fields) {
      let el = document.querySelector(`meta[${attribute}="${key}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attribute, key); document.head.appendChild(el); }
      el.content = content;
    }
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', SITE_ORIGIN + page.path);
    document.querySelectorAll('script[data-page-schema]').forEach(el => el.remove());
    for (const schema of pageSchema(page)) {
      const el = document.createElement('script'); el.type = 'application/ld+json'; el.dataset.pageSchema = 'true';
      el.textContent = JSON.stringify(schema); document.head.appendChild(el);
    }
  }, [pathname]);
  return null;
}
